import { useState, useEffect, useCallback } from 'react';

import useFetch, { CachePolicies } from 'use-http';

import { API_ROUTES } from '../../constants';

import {
  TAPIResponseDescription,
  IDescriptionData,
  TResponseData,
} from './description.types';

type TUseAPIFetchApplicationDescriptionParams = {
  applicationId: string;
};

export default function useAPIFetchApplicationDescription({
  applicationId,
}: TUseAPIFetchApplicationDescriptionParams): TAPIResponseDescription {
  const { get, post, put, error, loading, response, data } = useFetch(
    API_ROUTES.APPLICATIONS,
    {
      cachePolicy: CachePolicies.NO_CACHE,
    }
  );

  const fetchDescription = useCallback(async (): Promise<void> => {
    const data = await get(`${applicationId}/description`);

   return data
  }, [get, applicationId]);

  const addDescription = useCallback(
    async (body: IDescriptionData): Promise<void> => {
      const  data  = await post(`${applicationId}/description`, body);
     return data
    },
    [post, applicationId]
  );

  const updateDescription = useCallback(
    async (body: IDescriptionData): Promise<void> => {
      const  data  = await put(`${applicationId}/description`, body);

      return data
    },
    [put, applicationId]
  );

  useEffect(() => {
    fetchDescription();
    // eslint-disable-next-line
  }, []);

  return {
    data: data?.data || data,
    loading,
    error,
    loaded: response.ok,
    fetchDescription,
    updateDescription,
    addDescription,
  };
}
